var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/one_column.79be4dcc.png","uri@3x": __webpack_public_path__ + "static/media/one_column.271b959b.png","uri@2x": __webpack_public_path__ + "static/media/one_column.a794f581.png",
    width: 32,
    height: 32
});